import React, { Component } from 'react'
import MenuBar from '../../layouts/MenuBar'
import '../../styles/style.css'
import Footer from '../../layouts/Footer'
import { connect } from 'react-redux'
import { toast, ToastContainer } from 'react-toastify'
import { signUp } from '../../state-management/actions/auth/SignUpActions'
import PropTypes from 'prop-types'
import Helper from '../../utils/Helper'
import { stringify } from 'qs'
import { getCities, getCountries } from '../../state-management/actions/location/location-action'
import Delta from '../../assets/img/Delta.jpeg'
import AkwaIbom from '../../assets/img/AkwaIbom.jpeg'
import Banner from '../../assets/img/banner.jpeg'
import Abia from '../../assets/img/abia.jpeg'
import Anambra from '../../assets/img/anambra.jpeg'
import Imo from '../../assets/img/imo.jpeg'
import Enugu from '../../assets/img/enugu.jpeg'
import Abuja from '../../assets/img/abuja.jpeg'
import Kano from '../../assets/img/kano.jpeg'
import Kaduna from '../../assets/img/kaduna.jpeg'
import Crossriver from '../../assets/img/cross.jpeg'

class SignUp extends Component {
  constructor(props) {
    super(props)

    this.state = {
      first: '',
      last: '',
      address: '',
      address2: '',
      email: '',
      alternateEmail: '',
      phone: '',
      alternatePhoneNumber: '',
      referral: '',
      passsword: '',
      state: '',
      houseNumber: '', // Add house number to the state

      plan: '',
      direction: '',
      amount: '',
      about: '',
      source: '',
      phoneError: '',
      terms: false,
      // city: '',
      country: '',
      payment_option: 'paystack',
    }
  }

  static propTypes = {
    load: PropTypes.bool.isRequired,
  }

  signUp = (e) => {
    e.preventDefault()
    const {
      first,
      last,
      address,
      address2,
      email,
      phone,
      alternatePhoneNumber,
      source,
      nin,
      lat,
      lng,
      direction,
      // city,
      houseNumber,
      country,
      state,
      payment_option,
    } = this.state
    const { location } = this.props
    const price = location.state ? location.state.amount : 17500
    const data = {
      firstName: first,
      lastName: last,
      address,
      address2: address,
      houseNumber,
      lat: direction?.lat || '',
      lng: direction?.lng || '',
      // address: 'Atlantis 2 ologolo',

      email,
      phoneNumber: phone,
      alternatePhoneNumber: alternatePhoneNumber,
      language: 'english',
      allowEmail: true,
      plan: location.state ? location.state.planName : 'home',
      about_us: source,
      // city,
      country,
      state,
      payment_option,
    }

    const numbers = /^[0-9]+$/
    if (!phone.match(numbers)) {
      toast.info('Please enter only numbers')
    } else if (phone.length !== 11) {
      toast.info('invalid phone number')
    } else {
      this.props.signUp(data, price, this.props.history)
    }
  }

  onChange = (e) =>
    this.setState({
      [e.target.name]: e.target.value,
    })

  handleChange = (address) => {
    this.setState({ address })
  }

  handleInputChange = (event) => {
    const { name, type, checked, value } = event.target
    this.setState({
      [name]: type === 'checkbox' ? checked : value,
    })
  }

  handleNumber = (e) => {
    const { name, value } = e.target
    if (isNaN(Number(value))) return
    this.setState({ [name]: value })
  }

  handleSpaceBar = (e) => {
    if (e.keyCode === 32) e.preventDefault()
  }
  submitForm() {
    const { first, last, address, email, state, country, phone, alternatePhoneNumber, terms } = this.state
    return (
      first.length > 0 &&
      last.length > 0 &&
      address.length > 0 &&
      state.length > 0 &&
      // city.length > 0 &&
      country.length > 0 &&
      email.length > 0 &&
      phone.length === 11 &&
      terms
    )
  }

  componentDidMount() {
    this.props.getCountries()
  }

  displayStateAndRegions = () => {
    if (this.state.country === 'gh') {
      return this.props.countries
        .filter((country) => country.country === 'Ghana')
        .map((state) => <option value={state.state}>{state.state}</option>)
    } else if (this.state.country === 'cv') {
      return this.props.countries
        .filter((country) => country.country === "Cote d'Ivoire")
        .map((state) => <option value={state.state}>{state.state}</option>)
    }

    return this.props.countries
      .filter((country) => country.country === 'Nigeria')
      .map((state) => <option value={state.state}>{state.state}</option>)
  }
  displayPaymentOptions = () => {
    let options_payments = [
      {
        option: 'paystack',
        description: 'Pay Online Using Paystack ',
      },
    ]
    return options_payments.map((payment_option) => (
      <option value={payment_option.option}> {payment_option.description} </option>
    ))
  }

  showPaymentAmount(state) {
    if (state) {
      return Helper.formatCurrency(state.amount)
    }
    if (this.state.payment_option === 'paddy-cover') {
      const amount = Number(state.amount) + 500
      return Helper.formatCurrency(amount)
    }
    return Helper.formatCurrency(17500)
  }

  render() {
    const { load, location } = this.props
    const isEnabled = this.submitForm()

    const { first, last, address, email, phone, alternatePhoneNumber, terms } = this.state
    return (
      <div>
        <MenuBar />

        <div className="container-fluid top">
          <div className="container-fluid back ">
            <img src={Banner} alt="banner" className="over2"></img>
            <div className="row tite">
              <div className="col-md-6 text-left">
                <h1>We are on our way! </h1>

                <p>
                  Pay N30,000 only for installation instead of N69,500 and get one month FREE Unlimited internet. Offer
                  limited to Delta, Akwa Ibom, Cross River, Abia, Anambra, Imo, Enugu, Kaduna, Kano residents
                  ONLY as installations will start September 19th, 2023.
                </p>

                <h5 className="mt-5">Signup For</h5>
                <h6>{location.state ? location.state.plan : 'Residential Unlimited'}</h6>
                <form className="form-horizontal mt-3" onSubmit={this.signUp}>
                  <div className="form-group text-left">
                    <div className="d-flex">
                      <div className="mb-3 mr-auto col pl-0">
                        <label>First Name</label>
                        <input
                          type="text"
                          name="first"
                          value={first}
                          onChange={this.onChange}
                          className="form-control"
                          placeholder="First Name"
                        />
                      </div>

                      <div className="mb-3 col pr-0">
                        <label>Last Name</label>
                        <input
                          type="text"
                          className="form-control"
                          name="last"
                          value={last}
                          onChange={this.onChange}
                          placeholder="Last Name"
                        />
                      </div>
                    </div>

                    <div className="mb-3">
                      <label>Phone Number</label>
                      <input
                        type="tel"
                        pattern="0[789]{1}[01]{1}[0-9]{8}"
                        title="Please enter your valid 11-digit phone number"
                        className="form-control"
                        name="phone"
                        value={phone}
                        maxLength="11"
                        placeholder="Phone number"
                        onChange={this.handleNumber}
                        onKeyDown={this.handleSpaceBar}
                      />
                    </div>

                    <div className="mb-3">
                      <label>Alternate Phone Number</label>
                      <input
                        type="tel"
                        pattern="0[789]{1}[01]{1}[0-9]{8}"
                        title="Please enter your valid 11-digit phone number"
                        className="form-control"
                        name="alternatePhoneNumber"
                        value={alternatePhoneNumber}
                        maxLength="11"
                        placeholder="Phone number"
                        onChange={this.handleNumber}
                        onKeyDown={this.handleSpaceBar}
                      />
                    </div>

                    <div className="mb-3">
                      <label>Email Address</label>
                      <input
                        type="email"
                        name="email"
                        value={email}
                        onChange={this.onChange}
                        className="form-control"
                        placeholder="Contact email address"
                      />
                    </div>

                    <div className="mb-3">
                      <label>How Did You Hear About Us?</label>
                      <select className="form-control" name="source" onChange={this.onChange}>
                        <option value="">Select</option>
                        <option value="bbn">Big Brother Naija</option>
                        <option value="google ads">Google Ads</option>
                        <option value="facebook">Facebook</option>
                        <option value="linkedin">LinkedIn</option>
                        <option value="flyer">Flyer</option>
                        <option value="billboard">Billboard</option>
                        <option value="mobile advert">Mobile Advert</option>
                        <option value="friend">Friend</option>
                        <option value="instagram">Instagram</option>
                        <option value="television">Television</option>
                        <option value="radio">Radio</option>
                        <option value="other">Other</option>
                      </select>
                    </div>

                    <div className="mb-3">
                      <label>Country</label>
                      <select className="form-control" name="country" onChange={this.onChange} required>
                        <option required>Select Country</option>
                        <option value="ng"> Nigeria</option>
                        <option value="gh"> Ghana</option>
                        <option value="cv"> Cote d'Ivoire</option>
                      </select>
                    </div>

                    <div className="mb-3">
                      <label>State</label>
                      <select
                        className="form-control"
                        name="state"
                        onChange={(e) => {
                          this.onChange(e)
                        }}
                        required
                      >
                        <option>Select State</option>
                        {this.displayStateAndRegions()}
                      </select>
                    </div>

                    <div className="mb-3">
                      <label>House Number</label>
                      <input
                        type="text"
                        className="form-control"
                        name="houseNumber"
                        value={this.state.houseNumber}
                        onChange={this.onChange}
                        placeholder="Enter house number"
                      />
                    </div>

                    <div className="mb-3">
                      <label>Physical Address</label>
                      <textarea
                        className="form-control"
                        name="address"
                        value={address}
                        onChange={this.onChange}
                        placeholder="Enter physical address"
                        rows="3"
                        required
                      />
                    </div>

                    <>
                      <input
                        type="checkbox"
                        name="terms"
                        className="check"
                        checked={terms}
                        onChange={this.handleInputChange}
                      />
                      <label htmlFor="vehicle1">
                        By signing up, you agree to our{' '}
                        <a href="http://wifi.com.ng/terms" className="terms-link">
                          Terms and Conditions
                        </a>
                      </label>
                    </>
                    <div className="mb-3">
                      {load ? (
                        <input
                          disabled={true}
                          className="btn signup-btn w-100 text-white"
                          value="Submitting..."
                          type="submit"
                        />
                      ) : (
                        <input
                          disabled={!isEnabled}
                          className="btn signup-btn w-100 text-white"
                          value="Proceed"
                          type="submit"
                        />
                      )}
                    </div>
                  </div>
                </form>
              </div>
              <div className="col-md-6 col-md-offset-2 aside">
                <div className="container-fluid states">
                  <h1 className="text-left">Our Next Ten States </h1>

                  <div className="row">
                    <div className="p-2 col-6 col-md-4">
                      {' '}
                      <img src={Delta} alt="girl" className="over1"></img>
                      <div className="after">
                        <h6 className="title">DELTA STATE</h6>
                      </div>
                    </div>
                    <div className="p-2 col-6 col-md-4">
                      {' '}
                      <img src={AkwaIbom} alt="girl" className="over1"></img>
                      <div className="after">
                        <h6 className="title">AKWA IBOM</h6>
                      </div>
                    </div>
                    <div className="p-2 col-6 col-md-4">
                      {' '}
                      <img src={Crossriver} alt="girl" className="over1"></img>
                      <div className="after">
                        <h6 className="title">CROSS RIVER</h6>
                      </div>
                    </div>

                    <div className="p-2 col-6 col-md-4">
                      {' '}
                      <img src={Abia} alt="girl" className="over1"></img>
                      <div className="after">
                        <h6 className="title">ABIA</h6>
                      </div>
                    </div>
                    <div className="p-2 col-6 col-md-4">
                      {' '}
                      <img src={Anambra} alt="girl" className="over1"></img>
                      <div className="after">
                        <h6 className="title">ANAMBRA</h6>
                      </div>
                    </div>
                    <div className="p-2 col-6 col-md-4">
                      {' '}
                      <img src={Imo} alt="girl" className="over1"></img>
                      <div className="after">
                        <h6 className="title">IMO</h6>
                      </div>
                    </div>

                    <div className="p-2 col-6 col-md-4">
                      {' '}
                      <img src={Enugu} alt="girl" className="over1"></img>
                      <div className="after">
                        <h6 className="title">ENUGU</h6>
                      </div>
                    </div>
                    <div className="p-2 col-6 col-md-4">
                      {' '}
                      <img src={Kano} alt="girl" className="over1"></img>
                      <div className="after">
                        <h6 className="title">KANO</h6>
                      </div>
                    </div>

                    <div className="p-2 col-6 col-md-4">
                      {' '}
                      <img src={Kaduna} alt="girl" className="over1"></img>
                      <div className="after">
                        <h6 className="title">KADUNA</h6>
                      </div>
                    </div>
                    <div className="p-2 col-6 col-md-4"> </div>
                    <div className=" p-2 col-6 col-md-4"> </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <ToastContainer />
        <Footer />
      </div>
    )
  }
}
const mapStateToProps = (state) => ({
  load: state.signUp.load,
  countries: state.location.countries,
  cities: state.location.cities,
  gettingCities: state.location.gettingCities,
})

export default connect(mapStateToProps, {
  signUp,
  getCountries,
  getCities,
})(SignUp)
